var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_vm._l((_vm.pages),function(page){return [_c('div',{key:page},[_c('router-link',{attrs:{"to":("/kongkoo/user/" + page + "?preview=1")}},[_vm._v(" "+_vm._s(page)+" ")])],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }